import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, axiosInstance } from "lib";

export const changeCompanySubscription = createAsyncThunk(
  "Get Comapny",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        API.Change_Company_Subscription,
        data
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
//in plan
export const changeSubscriptionStatus = createAsyncThunk(
  "Subcription Status",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        API.Change_Subscription_Status,
        data
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
